<app-ctr-base
  [templateRef]="paymentInfo"
  [title]="title"
  [categoryProperties]="categoryProperties"
  [dataSelects]="dataSelects"
  [summary]="summary"
></app-ctr-base>

<ng-template #paymentInfo>
  <app-payment-info [statement]="statement" [dataSelects]="dataSelects" [showPriceChangeInfo]="true"> </app-payment-info>
</ng-template>
